import React from 'react';
import { Box, CircularProgress, useTheme } from '@mui/material';
import { MarketingCampaignWithSource } from '../../../types/marketing';
import { getCampaignPreviewUrl } from '../../../helpers/marketing';
import EnlargableImage from '../../global/EnlargeableImage';

interface Props {
  campaign: MarketingCampaignWithSource;
}

function CampaignPreviewImage({ campaign }: Props) {
  const [loading, setLoading] = React.useState(true);

  const theme = useTheme();

  return (
    <Box width="100%" overflow="hidden">
      {loading && (
        <Box
          flex={1}
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="center">
          <CircularProgress color="primary" size={20} />
        </Box>
      )}
      <EnlargableImage
        src={getCampaignPreviewUrl(campaign)}
        alt="Campaign Preview"
        style={{
          width: '100%',
          height: loading ? '0px' : 'auto',
          objectFit: 'contain',
          borderRadius: theme.shape.borderRadius,
        }}
        onLoad={() => setLoading(false)}
        closeButton
      />
    </Box>
  );
}

export default CampaignPreviewImage;
